module.exports = __webpack_public_path__ + "/653f93c3cb58cb7f21b6a721ebdbec19.jpg";